import NorthIndia from "./NorthIndia";
import { useState } from "react";
import "./Offices.css";
import WestIndia from "./WestIndia";
import EastIndia from "./EastIndia";
import SouthIndia from "./SouthIndia";

const Offices = () => {
  const [northbtn, setNorthbtn] = useState(false);
  const handleClick = (setbtn) => {
    setNorthbtn(setbtn);
    setWestbtn(false);
    setEastbtn(false);
    setSouthbtn(false);
  };
  const [westbtn, setWestbtn] = useState(false);
  const handleClick2 = (setbtn) => {
    setWestbtn(setbtn);
    setNorthbtn(false);
    setEastbtn(false);
    setSouthbtn(false);
  };
  const [eastbtn, setEastbtn] = useState(false);
  const handleClick3 = (setbtn) => {
    setEastbtn(setbtn);
    setNorthbtn(false);
    setWestbtn(false);
    setSouthbtn(false);
  };
  const [southbtn, setSouthbtn] = useState(false);
  const handleClick4 = (setbtn) => {
    setSouthbtn(setbtn);
    setNorthbtn(false);
    setWestbtn(false);
    setEastbtn(false);
  };

  return (
    <div>
      <div className="contact_div212">
        <h2>Circle offices across India</h2>
        <div className="contact_div3">
          
            <button
              class="button-3 btn3"
              role="button"
              onClick={() => handleClick(!northbtn)}
            >
              North India
            </button>
            <div className="loc_div_hide">{northbtn && <NorthIndia />}</div>
          

          <button
            class="button-3 btn3"
            role="button"
            onClick={() => handleClick2(!westbtn)}
          >
            West India
          </button>
          <div className="loc_div_hide"> {westbtn && <WestIndia />}</div>

          <button
            class="button-3 btn3"
            role="button"
            onClick={() => handleClick3(!eastbtn)}
          >
            East India
          </button>
          <div className="loc_div_hide"> {eastbtn && <EastIndia />}</div>

          <button
            class="button-3 btn3"
            role="button"
            onClick={() => handleClick4(!southbtn)}
          >
            South India
          </button>
          <div className="loc_div_hide"> {southbtn && <SouthIndia />}</div>
        </div>
      </div>
      <div className="loc_div_hide_desk">
        {northbtn && <NorthIndia />}
        {westbtn && <WestIndia />}
        {eastbtn && <EastIndia />}
        {southbtn && <SouthIndia />}
      </div>
    </div>
  );
};

export default Offices;
